export const slugifyTrainingGroup = (value) => String(value || '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

export const buildTrainingGroupPath = (groupTitle) => `/egitimlerimiz/${slugifyTrainingGroup(groupTitle)}`;

export const findTrainingGroupBySlug = (groupEntries, groupSlug) => {
  if (!groupSlug) return null;
  return groupEntries.find(([groupTitle]) => slugifyTrainingGroup(groupTitle) === groupSlug) || null;
};
